export default __webpack_public_path__ + "static/media/referralCardsHero.896f4721.jpg";